export const CONSUMER_TAB_VALUES = {
  GENERAL: "general",
  REGULATORY_DATA: "regulatorische-daten",
  PRICE_DATA: "preisdaten",
  HISTORY: "historie"
} as const;

export type ConsumerTabValue =
  (typeof CONSUMER_TAB_VALUES)[keyof typeof CONSUMER_TAB_VALUES];

export const CONSUMER_WIZARD_TABS: Array<{
  value: ConsumerTabValue;
  label: string;
}> = [
  { value: CONSUMER_TAB_VALUES.GENERAL, label: "Allgemeine Daten" },
  { value: CONSUMER_TAB_VALUES.REGULATORY_DATA, label: "Regulatorische Daten" },
  { value: CONSUMER_TAB_VALUES.PRICE_DATA, label: "Preisdaten" },
  { value: CONSUMER_TAB_VALUES.HISTORY, label: "Historie" }
];
